import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider, AuthProvider } from "@/context/SiteContext";
import { Header, Footer } from "@/components/site/Layout";
import Home from "@/pages/Home";
import { Services, ServiceDetail } from "@/pages/Services";
import { Publications, PublicationDetail } from "@/pages/Publications";
import { News, NewsDetail, Leadership, About } from "@/pages/Content";
import { Contact, Privacy, SearchPage } from "@/pages/Misc";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/Admin";

function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <>
      <a href="#main" className="skip-link" data-testid="skip-link">Skip to main content</a>
      <Header />
      <main id="main" tabIndex={-1} className="outline-none"><Outlet /></main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/leadership" element={<Leadership />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/publications" element={<Publications />} />
                <Route path="/publications/:slug" element={<PublicationDetail />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:slug" element={<NewsDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
              <Route path="/admin" element={<AuthProvider><AdminDashboard /></AuthProvider>} />
            </Routes>
            <Toaster position="top-right" />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
